var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "反馈",
            visible: _vm.dialogVisible,
            width: "40%",
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: { model: _vm.addForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "详细描述",
                    prop: "feedback_content",
                    rules: {
                      required: true,
                      message: "请填写！",
                      trigger: "change",
                    },
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input__width",
                    attrs: {
                      placeholder: "详细描述遇到的问题 或 需要协助的事项",
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 500 },
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addForm.feedback_content,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "feedback_content", $$v)
                      },
                      expression: "addForm.feedback_content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.subMitLoading },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }